import React, { Fragment, useState } from "react";
import "../Reporting.css";
import ReportingModals from "../../../../shared/Modals/ReportingModals";
import arrowImg from "../../../../assets/purple.svg";
import { Pie } from "@visx/shape";
import { Group } from "@visx/group";
import { scaleOrdinal } from "@visx/scale";
import { Text } from "@visx/text";
import { getDoctorBillings } from "../api";

const TotalRevenue = (props) => {
  const [lgShow, setLgShow] = useState(false);
  const [billingData, setBillingData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Define chart dimensions with proportional values
  const width = "100%";
  const height = "100%";
  const aspectRatio = "1.1";
  const margin = { top: "5%", right: "5%", bottom: "5%", left: "5%" };

  // Define colors for the pie chart
  const getColor = scaleOrdinal({
    domain: ["This Week", "Last Week", "This Month"],
    range: ["#6C5DD3", "#7FBA7A", "#FFCE73"]
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getDoctorBillings();
        console.log("Total Revenue Data:", res);
        setBillingData(res);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // Calculate total revenue
  const calculateTotal = () => {
    if (!billingData || billingData.length === 0) return 0;
    return billingData.reduce((total, item) => total + item.value, 0).toFixed(2);
  };

  // Function to render pie chart
  const renderPieChart = () => {
    if (loading) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '13rem',
          width: '100%'
        }}>
          <div>Loading revenue data...</div>
        </div>
      );
    }

    if (!billingData || billingData.length === 0) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '13rem',
          width: '100%'
        }}>
          <div>No revenue data available</div>
        </div>
      );
    }

    return (
      <div className="revenue-chart-container" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '15.6rem',
          aspectRatio: aspectRatio,
          position: 'relative'
        }}>
          <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
            <Group top={50} left={50}>
              <Pie
                data={billingData}
                pieValue={(d) => d.value}
                outerRadius={42}
                innerRadius={25}
                padAngle={0.02}
              >
                {(pie) => {
                  return pie.arcs.map((arc, index) => {
                    const { title } = arc.data;
                    const arcPath = pie.path(arc);
                    const arcFill = getColor(title);

                    return (
                      <g key={`arc-${index}`}>
                        <path d={arcPath} fill={arcFill} />
                      </g>
                    );
                  });
                }}
              </Pie>
              {/* Add total in the center */}
              <Text
                x={0}
                y={-6}
                textAnchor="middle"
                fontSize={9}
                fontWeight="bold"
                fill="#333"
              >
                Total
              </Text>
              <Text
                x={0}
                y={10}
                textAnchor="middle"
                fontSize={10}
                fontWeight="bold"
                fill="#6C5DD3"
              >
                {calculateTotal()}
              </Text>
            </Group>
          </svg>
        </div>
        <div className="legend" style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '0.5rem',
          flexWrap: 'wrap',
          width: '100%'
        }}>
          {billingData.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', margin: '0.1rem 0.65rem' }}>
              <div
                style={{
                  width: '0.8125rem',
                  height: '0.8125rem',
                  backgroundColor: getColor(item.title),
                  marginRight: '0.325rem',
                  borderRadius: '0.16rem'
                }}
              />
              <span style={{ fontSize: '0.975rem' }}>
                {item.title}: {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div onClick={(e) => { props?.check ? setLgShow(true) : e.preventDefault(); }}>
        <span className="patient_style">
          Total Revenue
          <img src={arrowImg} alt="" className="arrow-img ml-2" />
        </span>
      </div>
      <div
        onClick={(e) => {
          props?.check ? setLgShow(true) : e.preventDefault();
        }}
        id={props?.divId}
        style={{ padding: '0.8125rem' }}
      >
        {renderPieChart()}
      </div>
      {setLgShow ? (
        <ReportingModals
          setLgShow={setLgShow}
          lgShow={lgShow}
          show={4}
          title={"Total Revenue"}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default TotalRevenue;
